import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";
export const getVendorList = createAsyncThunk('/thunk/get-vendor-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-vendor-list`,{page:1})
        // console.log(response)
        return response
    } catch (error) {
        throw error
    }
})
